<template>
  <div class="login-container">
    <img src="../assets/img/logo.png" class="logo" alt="logo" :style="{ width:'149px'}" />
    <h2 :style="{ fontSize: '32px', marginTop: '24px' }">OPSIS by Stinger Cloud</h2>
    <a-tabs v-model:activeKey="activeTab" class="login-form">
      <a-tab-pane key="phone" tab="Phone">
        <a-form @submit.prevent="smsSending ? loginWithPhone() : requestNumber()" :model="formStatePhone">
          <label for="phone" :style="{ color: '#ADB5BD', fontSize: '14px' }">Cell Phone Number</label>
          <a-form-item name="phone" :rules="[{ required: true, message: 'Please input your phone!' }]">
            <a-input v-model:value="formStatePhone.phone" :style="{ height: '40px', background: '#343A40' }" placeHolder="10 digits (numbers only), e.g. (123)456-7890"></a-input>
          </a-form-item>
          
          <div v-if="smsSending">
            <label for="code" :style="{ color: '#ADB5BD', fontSize: '14px', margin: 0 }">Authentication Code</label>
            <a-form-item name="code" :rules="[{ required: true, message: 'Please input the code!' }]">
              <div style="display:flex; gap:8px; align-items:center;">
                <a-input v-model:value="formStatePhone.code" :style="{ height: '40px', background: '#343A40' }" placeHolder="Enter 5 digit-code"></a-input>
                <a-button @click="requestSms" :loading="isLoading" :style="{ height: '40px',}">Re-Send</a-button>
              </div>
            </a-form-item>
          </div>
          
          <a-form-item>
            <a-button
              :block="true"
              html-type="submit"
              :style="{ height: '40px', marginTop: '24px', background: '#F8DD4A', color: 'black' }"
              :loading="isLoading"
            >
              {{ isLoading ? '' : (smsSending ? 'Sign In' : 'Request Number') }}
            </a-button>
            <div :style="{ color: '#a61d24' }">{{ message }}</div>
          </a-form-item>
        </a-form>
      </a-tab-pane>
      <a-tab-pane key="email" tab="Email">
        <a-form @submit.prevent="login" :model="formState">
          <label for="email" :style="{ color: '#ADB5BD', fontSize: '14px', margin: 0 }">Email</label>
          <a-form-item name="email" :rules="[{ required: true, message: 'Please input your email!' }]">
            <a-input v-model:value="formState.email" :style="{ height: '40px', background: '#343A40' }" placeHolder="Enter your email"></a-input>
          </a-form-item>
          <label for="password" :style="{ color: '#ADB5BD', fontSize: '14px', margin: 0 }">Password</label>
          <a-form-item name="password" :rules="[{ required: true, message: 'Please input your password!' }]">
            <a-input-password v-model:value="formState.password" :style="{ height: '40px', background: '#343A40' }" placeHolder="Enter your password">
            </a-input-password>
          </a-form-item>
          
          <div style="display:flex; justify-content:flex-end;">
            <button type="button" @click="handleClickForgotPass" class="button1">Forgot Password?</button>
          </div>
          <a-form-item>
            <a-button
              :block="true"
              html-type="submit"
              :style="{ height: '40px', marginTop: '24px', background: '#F8DD4A', color: 'black' }"
              :loading="isLoading"
            >
              {{ isLoading ? '' : 'Sign In' }}
            </a-button>
            <div :style="{ color: '#a61d24' }">{{ message }}</div>
          </a-form-item>
        </a-form>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import loginService from '../services/login';

export default {
  data() {
    return {
      activeTab: 'phone',
      formState: {
        email: '',
        password: '',
      },
      formStatePhone: {
        phone: '',
        code: '',
      },
      message: '',
      isLoading: false,
      smsSending: false,
    };
  },
  methods: {
    async login() {
      const email = (this.formState.email || '').trim().toLowerCase();
      this.formState.email = email;
      if (!email || !this.formState.password) return;

      this.isLoading = true;
      const res = await loginService.login(email, this.formState.password, 'email');
      this.isLoading = false;
      if (!res.r) {
        this.message = res.message;
        return;
      }

      this.$store.dispatch('login', { user: res.member, token: res.token });
      this.$router.push('/');
    },

    async requestNumber() {
      if (!this.formStatePhone.phone) return;
      this.smsSending = true;
      this.isLoading = true;
      try {
        const res = await loginService.requestSms(this.formStatePhone.phone);
        if (!res.r) {
          this.message = res.msg || 'Failed to send SMS';
        }
      } catch (e) {
        this.message = 'Failed to send SMS';
      }
      this.isLoading = false;
    },

    async loginWithPhone() {
      if (!this.formStatePhone.phone || !this.formStatePhone.code) return;
      this.isLoading = true;
      const res = await loginService.login(this.formStatePhone.phone, this.formStatePhone.code, 'phone');
      this.isLoading = false;
      if (!res.r) {
        this.message = res.message;
        return;
      }

      this.$store.dispatch('login', { user: res.member, token: res.token });
      this.$router.push('/');
    },

    handleClickForgotPass() {
      console.log('forgot password');
      this.$router.push('/forgot-password');
    },

    async requestSms() {
      if (!this.formStatePhone.phone) return;
      this.smsSending = true;
      try {
        const res = await loginService.requestSms(this.formStatePhone.phone);
        if (!res.r) {
          this.message = res.msg || 'Failed to send SMS';
        } else {
          this.message = 'Code sent.';
        }
      } catch (e) {
        this.message = 'Failed to send SMS';
      }
      this.smsSending = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.logo {
  margin-top: 174px;
}
.login-form {
  margin-top: 36px;
  width: 328px;
  display: flex;
  flex-direction: column;
}
.button1 {
  padding:1px 0px;
  margin-left:auto;
  text-decoration: underline;
  color: #F8DD4A;
}
</style>
